import { render, staticRenderFns } from "./icv2_email.vue?vue&type=template&id=cb0ef26a&"
import script from "./icv2_email.vue?vue&type=script&lang=js&"
export * from "./icv2_email.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports